import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { KursService } from '../_services/kurs.service';
import { Kurs } from '../_models/kurs';
import { Klassenbuch } from '../_models/klassenbuch';
import { InhalteService } from '../_services/inhalte.service';
import { KursKlassenbuch } from '../_models/KursKlassenbuch';
import { AuthenticationService } from '../_services/authentication.service';
import { User } from '../_models/user';
import { fromPromise } from 'rxjs/observable/fromPromise';


@Component({
  selector: 'choose-courses',
  templateUrl: './choose-courses.component.html',
  styles: ['.list-group{max-height: 300px;margin-bottom: 10px;overflow-y: auto;-webkit-overflow-scrolling: touch;}']
})
export class ChooseCoursesComponent implements OnInit {

  constructor(private courseService: KursService, private entryService: InhalteService, private authenticationService: AuthenticationService) {
    this.classBookEntry = new Klassenbuch(new Date(this.classBookEntryDate));
    this.classBookEntry.inhalte = "Kein Inhalt";
    this.classBookEntry.trainer = "Trainer";
    this.classBookEntry.thema = "Thema";
    this.classBookEntry.eintragsDatum = this.classBookEntry.eintragsDatum.substr(0, 10);
    console.log(this.classBookEntry.eintragsDatum);
  }

  @ViewChild('modal') modal;

  ngOnInit() {
    console.log("choose-courses onInit");
    console.log("getKursStandorte");
    this.courseService.getKursStandorte().subscribe(
      x => { this.sites = x; },
      err => console.log(err),
      () => {
        this.sites.sort((a, b) => { return a > b ? 1 : -1; });
        console.log("getKursStandorte finished");
      });
    console.log();
    console.log("getKurse");
    this.courseService.getKurse().subscribe(
      x => { this.courses = x; },
      err => console.log(err),
      () => {
        this.filteredCourses = this.courses
          .filter(this.activeCourseFilter);
        console.log("getKurse finished");
      }
    );
    console.log("get finished");
    //this.authenticationService.currentUser.subscribe(
    //  x => { this.currentUser = x; },
    //  err => { console.log(err); },
    //  () => {
    this.currentUser = this.authenticationService.currentUserValue;
    console.log("Currentuser:")
    console.log(this.currentUser);
    console.log("Roles: ");
    console.log(this.authenticationService.getRoles());
    console.log("IsTrainer: ");
    console.log(this.isTrainer);
    if (this.isTrainer) {
      this.entryService.GetEntryByTrainerToday(this.currentUser.displayName).subscribe(
        entry => this.classBookEntry = entry ? entry.shift() : this.classBookEntry,
        err => console.log(err),
        () => {
          console.log(this.selectedCourses);
          this.courseService.getCoursesByTrainerToday(this.currentUser.displayName).subscribe(
            c => this.selectedCourses = c,
            err => console.log(err),
            () => {
              let lengthOfCourseArray = this.selectedCourses.length;
              console.log("Count Trainer Courses today: " + lengthOfCourseArray);
              console.log(this.selectedCourses);
              for (var i = 0; i < lengthOfCourseArray; i++) {
                let c = this.selectedCourses.shift();
                console.log("Course #" + i + 1 + ":");
                console.log(c);
                this.selectedCourses.push(
                  this.filteredCourses.filter(
                    v => v.kursNr == c.kursNr).shift());
                this.filteredCourses.splice(this.filteredCourses.indexOf(this.selectedCourses[this.selectedCourses.length - 1]), 1);
                console.log(this.selectedCourses);
              }
            }
          )
        }
      )
    }
    //}
    //);
  }

  currentUser: User;
  sites: string[];
  site: string = "all";
  courses: Kurs[];
  filteredCourses: Kurs[];
  selectedCourses: Kurs[] = [];
  activeCourseOnly: boolean = true;
  activeCourseFilter: IFilter = (c, i, a) => { return !this.activeCourseOnly || c.kursEnde ? c.kursEnde.substr(0, 10) >= new Date().toISOString().substr(0, 10) : false }
  sitesFilter: IFilter = (c, i, a) => { return this.site == "all" ? true : c.ort == this.site }
  sortFilter: ISort = (a, b) => { return a.kursName > b.kursName ? 1 : -1 }
  btnChooseValue: string = "übernehmen"
  isTrainer: boolean;
  absenceChecked: boolean = false;
  classes: string = "list-group-item list-group-item-action";
  classBookEntryDate: string = new Date().toISOString().substr(0, 10);
  classBookEntry: Klassenbuch;
  //_reset: boolean = false;

  @Input()
  set reset(r: boolean) {
    if (r) {
      while (this.selectedCourses.length > 0)
        this.filteredCourses.push(this.selectedCourses.shift());
      this.absenceChecked = false;
      this.btnChooseValue = "übernehmen";
      this.classBookEntry = new Klassenbuch(new Date(this.classBookEntryDate));
      this.classBookEntry.inhalte = "Kein Inhalt";
      this.classBookEntry.trainer = "Trainer";
      this.classBookEntry.thema = "Thema";
      this.classBookEntry.eintragsDatum = this.classBookEntry.eintragsDatum.substr(0, 10);
    }
  }

  getClassBookEntry(): Klassenbuch {
    console.log("getClassBookEntry in choose:");
    console.log(this.classBookEntry);
    return this.classBookEntry;
  }

  @Output()
  assumeCourses: EventEmitter<Kurs[]> = new EventEmitter<Kurs[]>();

  @Input()
  set IsTrainer(isTrainer: boolean) {
    this.isTrainer = isTrainer;
    if (this.isTrainer) this.btnChooseValue = "übernehmen";
  };

  selectFromFilteredCourse(event) {
    let entryTemp: Klassenbuch = this.classBookEntry;
    let entriesTemp: Klassenbuch[];
    let finished: boolean = false;
    var clickedCourse = this.filteredCourses.filter(
      (a) => a.kursNr == event.target.id.substr(3)
    ).shift();
    this.entryService.GetKlassenbuchByKurs(clickedCourse.kursNr).subscribe(
      x => entriesTemp = x,
      err => console.log(err),
      () => {
        console.log("Einträge von Kurs " + clickedCourse.kursName + ": ");
        console.log(entriesTemp);
        entryTemp = entriesTemp.filter((entryToday) => entryToday.eintragsDatum.substr(0, 10) == this.classBookEntry.eintragsDatum.substr(0, 10)).shift();
        if (this.selectedCourses.length == 1) {
          this.classBookEntry = entryTemp ? entryTemp : this.classBookEntry; //erster ausgewählter Kurs
          this.classBookEntry.kurs = clickedCourse;
          if (!this.classBookEntry) {
            this.classBookEntry = new Klassenbuch(new Date(this.classBookEntryDate));
            this.classBookEntry.trainer = "Trainer";
            this.classBookEntry.thema = "Thema";
            this.classBookEntry.inhalte = "Kein Inhalt";
            this.classBookEntry.kurs = clickedCourse;
          }
        } else {//Kurs/e schon vorhanden
          if (entryTemp) { //Eintrag vorhanen
            console.log("classbookentry: ");
            console.log(this.classBookEntry);
            console.log(entryTemp);
            if (this.classBookEntry.klassenbuchNr == entryTemp.klassenbuchNr) {//Einträge identisch
              this.classBookEntry.kurs = clickedCourse;
            } else {//Einträge unterschiedlich
              entryTemp.kurs = clickedCourse//this.selectedCourses[this.selectedCourses.length - 1];
              this.MergeClassBookEntries(entryTemp);
            }
          } else { //kein Eintrag vorhanden
            this.classBookEntry.kurs = clickedCourse;
          }
        }
      }
    );
    //while (!finished) console.log("wait");
    console.log("Temp Eintrag:");
    console.log(entryTemp);
    this.selectedCourses.push(clickedCourse);
    this.filteredCourses.splice(this.filteredCourses.indexOf(clickedCourse), 1);
  }

  MergeClassBookEntries(entry: Klassenbuch)//: Klassenbuch
  {
    this.modal.show(this.classBookEntry, entry);
  }

  onConflictSolution(entries: Klassenbuch[]) {
    if (entries) {
      let entry = entries[0];
      let entryToDelete = entries[1];
      if (entry.kurs) {
        let EntrysToChange: KursKlassenbuch[];
        this.entryService.GetLookup().subscribe(
          lookup => EntrysToChange = lookup,
          err => console.log(err),
          () => {
            this.entryService.postLookupDelete(
              EntrysToChange.filter(etc =>
                etc.kursNummer == entryToDelete.kurs.kursNr &&
                etc.klassenbuchNummer == entryToDelete.klassenbuchNr).shift());
          }
        );
        entry.kurs = null;
      }
      else {
        //let EntrysToChange: KursKlassenbuch[];
        //this.entryService.GetLookup().subscribe(
        //  lookup => EntrysToChange = lookup,
        //  err => console.log(err),
        //  () => {
        //    let kkb = EntrysToChange.filter(
        //      (kkb, index, array) => this.selectedCourses[0].kursNr == kkb.kursNummer && kkb.klassenbuchNummer == entry.klassenbuchNr).shift();
        //    this.entryService.postLookupDelete(kkb).subscribe(
        //      back => console.log(back),
        //      err => console.log(err)
        //    );
        //  }
        //)
      }
      this.classBookEntry = entry;
    }
    else {
      //this.filteredCourses.push(this.selectedCourses.pop());
    }
    //this.filteredCourses.push(this.selectedCourses.pop());
  }



  selectFromSelectedCourse(event) {
    var c = this.selectedCourses.filter(
      (a) => a.kursNr == event.target.id.substr(3)
    ).shift();

    this.filteredCourses.push(c);
    this.selectedCourses.splice(this.selectedCourses.indexOf(c), 1);
  }

  onSiteChanged(event) {
    this.site = event.target.id;
    console.log(this.site);
  }

  checkSite(site: string): boolean {
    return site == this.site;
  }

  btnChooseValue_click() {
    this.absenceChecked = !this.absenceChecked;
    if (this.absenceChecked) {
      //this.classes = "list-group-item list-group-item-action list-group-item-danger";
      this.btnChooseValue = "freigeben";
      this.assumeCourses.emit(this.selectedCourses);
    } else {
      //this.classes = "list-group-item list-group-item-action list-group-item-succes";
      this.btnChooseValue = "übernehmen";

    }
  }
}

interface IFilter {
  (course: Kurs, index: number, array: Kurs[]): boolean;
}

interface ISort {
  (a: Kurs, b: Kurs): number;
}




// WEBPACK FOOTER //
// ./src/app/_components/choose-courses.component.ts